import secureLocalStorage from "react-secure-storage";
import api from "../../../api";

export function getBookingData(id) {
  return api.get(`v2/engagements?case_id=${id}&state=active`);
}
export function setChatData(id,message){
  return api.post(`case/${id}/chat`,{message})
}

export  function setTag(id,tag_id){
  return api.post(`case/${id}/addTag`,{tag_id})
}

export  function deleteTag(id,tag_id){
  return api.delete(`case/${id}/deleteTag`,{ data: { tag_id }})
}

export function setOrderType(id,requestObject){
  return api.put(`case/${id}/consult_call`,{...requestObject});
}

export function getNextEngagement(){
  return api.get(`v2/next-engagement/${secureLocalStorage.getItem('id')}`)
}

export function oralMinox(caseId){
  return api.get(`doctor-prescription-oral-minox/${caseId}`)
}